export default "https://npm-assets.fiverrcdn.com/assets/@fiverr/freelance_impact_perseus/freelance-economy-2024.383cbc1.pdf";